import { styled } from "../../../../lib/styled";
import type { CorpusFeedView } from "../../../../lib/corpusFeedView";
import { initials } from "../../../../lib/text";
import { ColoredAvatar } from "../../../primitives/data-display/ColoredAvatar";

// An emoji is a picture, so it fills the tile the way initials, which are text, should not.
const EmojiAvatar = styled(ColoredAvatar)(({ theme }) => ({
  fontSize: theme.typography.h3.fontSize,
}));

interface FeedAvatarProps {
  view: CorpusFeedView;
}

/** The mark standing for a feed: the emoji its name starts with, or else its initials. */
export function FeedAvatar({ view }: FeedAvatarProps) {
  return view.icon ? (
    <EmojiAvatar>{view.icon}</EmojiAvatar>
  ) : (
    <ColoredAvatar>{initials(view.name)}</ColoredAvatar>
  );
}
